import React from 'react';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const DownloadIcon = ({ color = 'black', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path d="M2.70129 7.27246L6.44155 11.1166L10.2857 7.27246" stroke={color} style={{ strokeMiterlimit: 10 }} />
      <path d="M6.44153 0V10.5974" stroke={color} style={{ strokeMiterlimit: 10 }} />
      <path d="M12.8831 15.5H0" stroke={color} style={{ strokeMiterlimit: 10 }} />
    </svg>
  );
};

export default DownloadIcon;
